var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuatro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 5,
    viewBox: "0 0 83 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4746 3.12267C65.5339 1.4167 49.3026 2.14653 33.3107 1.72738C22.736 1.44802 12.1629 0.902253 1.59559 0.659553C1.27876 0.652782 1.01587 0.918964 1.00859 1.25648C1.0015 1.59399 1.25285 1.87271 1.56949 1.87948C12.1356 2.12217 22.7076 2.66793 33.2811 2.94729C49.2443 3.36618 65.445 2.63405 81.3571 4.33774C81.6725 4.37094 81.954 4.12729 81.9875 3.79203C82.019 3.45676 81.7881 3.15788 81.4746 3.12267Z",
    fill: "#343434"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuatro);
export default __webpack_public_path__ + "static/media/quatro.93ffc5da9e714231769529c7174f0166.svg";
export { ForwardRef as ReactComponent };